/**
 * Default project headers
 */
// eslint-disable-next-line import/prefer-default-export
export const headers = {
  'x-q24-project': 'inpatient',
  'x-q24-user-agent': `PatientPWA/${process.env.REACT_APP_VERSION}`,
};
